import { CheckAffiliateBasedOnLEAndCountry } from './CheckAffiliateBasedOnLEAndCountry';

export { CheckAffiliateBasedOnLEAndCountry };

export default CheckAffiliateBasedOnLEAndCountry;